<!-- eslint-disable vue/no-v-html -->
<template>
  <v-dialog
    v-model="opened"
    max-width="400"
    scrollable
    persistent
    no-click-animation
    :retain-focus="false"
    @keydown.esc="hide"
  >
    <v-card>
      <v-btn class="v-dialog--close" icon @click="reject">
        <v-icon>fal fa-times</v-icon>
      </v-btn>
      <v-card-title class="headline pr-10">{{title}}</v-card-title>

      <v-card-text v-if="content" v-html="content"></v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn text @click="reject">{{cancel}}</v-btn>
        <v-btn text :color="acceptColor" @click="resolve">{{accept}}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  export let prompt;


  export default {
    name: 'Prompt',

    data() {
      return {
        opened: false,
        resolve: () => {},
        reject: () => {},
        title: 'Fortfahren?',
        content: '',
        accept: 'Ja',
        acceptColor: 'warning',
        cancel: 'Abbrechen'
      };
    },

    created() {
      prompt = this.prompt.bind(this);
    },

    methods: {
      /**
       * Prompt for acceptance
       * @param {Object|string} options or title
       * @param {string} options.title
       * @param {string} options.content
       * @param {string} options.accept
       * @param {string} options.acceptColor
       * @param {string} options.cancel
       */
      async prompt(options = {}) {
        if (typeof options === 'string') {
          options = {title: options};
        }

        try {
          await new Promise((resolve, reject) => {
            const defaults = this.$options.data();

            this.title = options.title || defaults.title;
            this.content = options.content || defaults.content;
            this.accept = options.accept || defaults.accept;
            this.acceptColor = options.acceptColor || defaults.acceptColor;
            this.cancel = options.cancel || defaults.cancel;

            this.resolve = resolve;
            this.reject = reject;

            this.opened = true;
          });

          this.opened = false;

        } catch (error) {
          // Prompt declined
          this.opened = false;
          throw new Error('declined');
        }
      }
    }
  };
</script>
